import {PropsWithChildren} from 'react';

import {classNames} from '../../util/css';

import * as styles from './page-header.scss';

type PropsType = PropsWithChildren<{
    className?: string;
}>;

export function PageHeader(props: PropsType): JSX.Element {
    const {className, children} = props;

    const fullClassName = classNames(styles.PageHeader, className);

    return <h1 className={fullClassName}>{children}</h1>;
}
